import { CORE_SYSTEM_ENUMS } from '@erp/shared-types';
import useCoreEnums, {
  CoreEnumOptionDTO,
} from 'src/api/core/core-enums/useCoreEnums';

export interface WatchRoleOption {
  id: string;
  value: string;
  label: string;
}

/**
 * Fetches the org-specific watch roles from the "Watch Roles" CoreEnum.
 * Returns an empty array if the org hasn't configured any roles.
 */
const useWatchRoles = () => {
  const { data, isLoading, error } = useCoreEnums({
    name: CORE_SYSTEM_ENUMS.WATCH_ROLES.name,
    includeOptions: true,
    first: 1,
  });

  const watchRolesEnum = data?.edges?.[0];
  const options = watchRolesEnum?.options ?? [];

  // Transform CoreEnumOptions to a simpler format
  const watchRoles: WatchRoleOption[] = options.map(
    (option: CoreEnumOptionDTO) => ({
      id: option.id,
      value: option.name ?? option.id,
      label: option.name ?? 'Unknown',
    }),
  );

  return {
    watchRoles,
    hasRoles: watchRoles.length > 0,
    isLoading,
    error,
  };
};

export default useWatchRoles;
